import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { cartSlice } from "./slices/cart-slice";
import { notificationSlice } from "./slices/notification-slice";

import { recaptchaSlice } from "./slices/recaptcha-slice";
import { userSlice } from "./slices/user-slice";

export const store = configureStore({
	reducer: combineReducers({
		notifications: notificationSlice.reducer,
		user: userSlice.reducer,
		cart: cartSlice.reducer,
		recaptcha: recaptchaSlice.reducer,
	}),
	devTools: import.meta.env.DEV,
});
